export enum NotificationDtoKeysEnum {
  /** Activity feed informer base filters */
  ACTIVITY_FEED_INFORMER_FILTERS_DTO = 'notification/activity-feed-informer-filters.dto',
  /** Activity feed informer item response body */
  ACTIVITY_FEED_INFORMER_ITEM_FIND_DTO = 'notification/activity-feed-informer-item-find.dto',
  /** Activity feed informer page response body */
  ACTIVITY_FEED_INFORMER_PAGE_FIND_DTO = 'notification/activity-feed-informer-page-find.dto',
  /** Activity feed informer query parameters */
  ACTIVITY_FEED_INFORMER_QUERY_DTO = 'notification/activity-feed-informer-query.dto',
  /** Bill mailing attachement response body */
  BILL_TARGET_ITEM_DTO = 'notification/bill-target-item.dto',
  /** Document mailing attachement response body */
  DOCUMENT_TARGET_ITEM_DTO = 'notification/document-target-item.dto',
  /** Debtors mailing addressee response body */
  DEBTOR_TARGET_ITEM_DTO = 'notification/debtor-target-item.dto',
  /** Debtors mailing addressees response body */
  DEBTOR_TARGETS_DTO = 'notification/debtor-targets.dto',
  /** E-Mail sender response body */
  EMAIL_SENDER_FIND_DTO = 'notification/email-sender-find.dto',
  /** E-Mail sender create/update request body */
  EMAIL_SENDER_FORM_DTO = 'notification/email-sender-form.dto',
  /** Unread notifications report API response body item */
  NOTIFICATION_UNREAD_REPORT_ITEM_DTO = 'notification/notification-unread-report-item.dto',
  /** Unread notifications report API query parameters */
  NOTIFICATION_UNREAD_REPORT_QUERY_DTO = 'notification/notification-unread-report-query.dto',
  /** Unread notifications report registry filters */
  NOTIFICATION_UNREAD_REPORT_FILTERS_DTO = 'notification/notification-unread-report-filters.dto',
  /** Unread notifications report registry column selection */
  NOTIFICATION_UNREAD_REPORT_REGISTRY_SELECT_DTO = 'notification/notification-unread-report-registry-select.dto',
  /** Unread notifications report registry sorting */
  NOTIFICATION_UNREAD_REPORT_REGISTRY_SORT_DTO = 'notification/notification-unread-report-registry-sort.dto',
  /** Unread notifications report registry query parameters */
  NOTIFICATION_UNREAD_REPORT_REGISTRY_QUERY_DTO = 'notification/notification-unread-report-registry-query.dto',
  /** Unread notifications report registry page response */
  NOTIFICATION_UNREAD_REPORT_REGISTRY_PAGE_DTO = 'notification/notification-unread-report-registry-page.dto',
  /** Notification blacklist status response body */
  NOTIFICATION_BLACKLIST_STATUS_DTO = 'notification/notification-blacklist-status.dto',
  /** Notifications blacklist API params */
  NOTIFICATION_BLACKLIST_PARAMS_DTO = 'notification/notification-blacklist-params.dto',
  /** Notification activity feed API query parameters */
  NOTIFICATION_QUERY_DTO = 'notification/notification-query.dto',
  /** Notification count response body */
  NOTIFICATION_COUNT_FIND_DTO = 'notification/notification-count-find.dto',
  /** Mailing and mailing template list APIs query parameters */
  MAILING_SEARCH_QUERY_DTO = 'notification/mailing-search-query.dto',
  /** Mailing selection settings */
  MAILING_SELECT_DTO = 'notification/mailing-select.dto',
  /** Mailing sorting settings */
  MAILING_SORT_DTO = 'notification/mailing-sort.dto',
  /** Mailing own filters */
  MAILING_FILTERS_DTO = 'notification/mailing-filters.dto',
  /** Mailing find many API query parameters */
  MAILING_FIND_MANY_QUERY_DTO = 'notification/mailing-find-many-query.dto',
  /** Mailing export to file API query parameters */
  MAILING_EXPORT_QUERY_DTO = 'notification/mailing-export-query.dto',
  /** Mailing file debtor response body */
  MAILING_FILE_DEBTOR_TARGET_FIND_DTO = 'notification/mailing-file-debtor-target-find.dto',
  /** Mailing file debtor create and update APIs body */
  MAILING_FILE_DEBTOR_TARGET_FORM_DTO = 'notification/mailing-file-debtor-target-form.dto',
  /** Mailing response body */
  MAILING_FIND_DTO = 'notification/mailing-find.dto',
  /** Mailings list slice response body */
  MAILING_PAGE_DTO = 'notification/mailing-page.dto',
  /** Mailing and mailing template common request body */
  MAILING_BASE_FORM_DTO = 'notification/mailing-base-form.dto',
  /** Mailing create and update APIs request body */
  MAILING_FORM_DTO = 'notification/mailing-form.dto',
  /** Mailing template base create and update API form fields */
  MAILING_TEMPLATE_BASE_FORM_DTO = 'notification/mailing-template-base-form.dto',
  /** Mailing template own filters */
  MAILING_TEMPLATE_FILTERS_DTO = 'notification/mailing-template-filters.dto',
  /** Mailing template find many API query parameters */
  MAILING_TEMPLATE_FIND_MANY_QUERY_DTO = 'notification/mailing-template-find-many-query.dto',
  /** Mailing template registry export to file API query parameters */
  MAILING_TEMPLATE_EXPORT_QUERY_DTO = 'notification/mailing-template-export-query.dto',
  /** Mailing template response body */
  MAILING_TEMPLATE_FIND_DTO = 'notification/mailing-template-find.dto',
  /** Mailing templates list slice response body */
  MAILING_TEMPLATE_PAGE_DTO = 'notification/mailing-template-page.dto',
  /** Mailing template selection settings */
  MAILING_TEMPLATE_SELECT_DTO = 'notification/mailing-template-select.dto',
  /** Mailing template sorting settings */
  MAILING_TEMPLATE_SORT_DTO = 'notification/mailing-template-sort.dto',
  /** Mailing template create and update APIs request body */
  MAILING_TEMPLATE_FORM_DTO = 'notification/mailing-template-form.dto',
  /** Default mailing senders response body */
  MAILING_DEFAULT_SENDERS_FIND_DTO = 'notification/mailing-default-senders-find.dto',
  /** Default mailing senders edit API request body */
  MAILING_DEFAULT_SENDERS_FORM_DTO = 'notification/mailing-default-senders-form.dto',
  /** Mailing history log entry response body */
  MAILING_HISTORY_FIND_DTO = 'notification/mailing-history-find.dto',
  /** Mailing history log entries page response body */
  MAILING_HISTORY_PAGE_DTO = 'notification/mailing-history-page.dto',
  /** Mailing template history log entry response body */
  MAILING_TEMPLATE_HISTORY_FIND_DTO = 'notification/mailing-template-history-find.dto',
  /** Mailing template history log entries page response body */
  MAILING_TEMPLATE_HISTORY_PAGE_DTO = 'notification/mailing-template-history-page.dto',
  /** Reminder response body */
  REMINDER_FIND_DTO = 'notification/reminder-find.dto',
  /** Reminder create or update request body */
  REMINDER_FORM_DTO = 'notification/reminder-form.dto',
  /** SMS sender response body */
  SMS_SENDER_FIND_DTO = 'notification/sms-sender-find.dto',
  /** SMS sender create/update request body */
  SMS_SENDER_FORM_DTO = 'notification/sms-sender-form.dto',
  /** Notification subject header */
  NOTIFICATION_SUBJECT_HEADER_DTO = 'notification/notification-subject-header.dto',
  /** Entity notifications subscription status response body */
  NOTIFICATION_SUBSCRIPTION_STATUS_DTO = 'notification/notification-subscription-status.dto',
  /** Notification settings entry common request and response body */
  NOTIFICATION_SETTINGS_ENTRY_DTO = 'notification/notification-settings-entry.dto',
  /** Notification settings common request and response body */
  NOTIFICATION_SETTINGS_DTO = 'notification/notification-settings.dto',
  /** Notification subject API response body item */
  NOTIFICATION_SUBJECT_FIND_DTO = 'notification/notification-subject-find.dto',
  /** Notification activity feed own filters */
  NOTIFICATION_FILTERS_DTO = 'notification/notification-filters.dto',
  /** Notification API response body item */
  NOTIFICATION_FIND_DTO = 'notification/notification-find.dto',
  /** Export task attached to a notification */
  NOTIFICATION_EXPORT_TASK_FIND_DTO = 'notification/notification-export-task-find.dto',
  /** Mark many notifications as read API query parameters */
  NOTIFICATION_MARK_MANY_AS_READ_QUERY_DTO = 'notification/notification-mark-many-as-read-query.dto',
  /** Notification page API response body item */
  NOTIFICATION_PAGE_FIND_DTO = 'notification/notification-page-find.dto',
  /** Activity feed notification */
  ACTIVITY_FEED_NOTIFICATION_FIND_DTO = 'notification/activity-feed-notification-find.dto',
  /** Activity feed notification params */
  ACTIVITY_FEED_NOTIFICATION_QUERY_DTO = 'notification/activity-feed-notification-query.dto',
  /** Activity feed result response body */
  ACTIVITY_FEED_RESULT_PAGE_DTO = 'notification/activity-feed-result-page.dto',
  /** Favorite informer objects JSON "page" */
  FAVORITE_INFORMER_PAGE_DTO = 'notification/favorite-informer-page.dto',
  /** Common entry with object added to "favorites": project, HD task */
  FAVORITE_INFORMER_FIND_DTO = 'notification/favorite-informer-find.dto',
  /** Expired entity informer item (result list element) */
  EXPIRED_INFORMER_ITEM_FIND_DTO = 'notification/expired-informer-item-find.dto',
  /** Popup settings for profile response body */
  POPUP_SETTINGS_FIND_DTO = 'notification/popup-settings-find.dto',
  /** Popup settings for profile response body */
  POPUP_SETTINGS_FORM_DTO = 'notification/popup-settings-form.dto',
}
